// State keeps bare digits, only the display is grouped; nb-NO uses U+00A0 and "kr" is an adornment

// Digits only, grouped for display. Empty string stays empty
export const formatCash = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  return digits === '' ? '' : Number(digits).toLocaleString('nb-NO');
};

// Same grouping for a number that may be negative — avvik is signed
export const formatSignedCash = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return '';
  }
  return Number(value).toLocaleString('nb-NO', { maximumFractionDigits: 0 });
};

// onChange body for a grouped cash field; counts digits before the caret so regrouping can't move it
export const readCashInput = (el) => {
  const raw = el.value;
  const caret = el.selectionStart ?? raw.length;

  return {
    // Leading zeros stripped: a field starting at 0 would show "01000" after typing 1000
    value: raw.replace(/\D/g, '').replace(/^0+(?=\d)/, ''),
    caretDigits: raw.slice(0, caret).replace(/\D/g, '').length,
  };
};

// Walk regrouped text and find the offset just past `caretDigits` digits
export const caretPositionForDigits = (text, caretDigits) => {
  if (caretDigits === 0) return 0;

  let seen = 0;
  for (let i = 0; i < text.length; i++) {
    if (/\d/.test(text[i])) {
      seen += 1;
      if (seen === caretDigits) return i + 1;
    }
  }
  return text.length;
};
